module.exports = __webpack_public_path__ + "img/verify-hk.518abe24.png";